import React, { useState } from 'react';
import ContactDialog from './ContactDialog';
import { translations } from '../../translations';

interface ContactButtonProps {
  language: string;
}

const ContactButton: React.FC<ContactButtonProps> = ({ language }) => {
  const [open, setOpen] = useState(false);
  const t = translations[language];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <button
        onClick={handleOpen}
        className="bg-[#4F46E5] text-white px-8 py-3 rounded-full flex items-center mx-auto hover:bg-[#4338CA] transition-colors hover:scale-105 transform duration-200 font-medium"
      >
        <span className="mr-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
          </svg>
        </span>
        {t.notifyMe}
      </button>
      <ContactDialog open={open} onClose={handleClose} language={language as 'fr' | 'en'} />
    </>
  );
};

export default ContactButton; 